import { Grid } from '@mui/material';
import { isDef } from '@utils/def';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import FormField from '../../../FormField';
import { InputTypes, Sizes } from '../../../Input';

import { FormFieldInputValueType, FormFields } from '../../types';
import { getGridColumnAmount, getValidationRulesFromAField } from '../../utils';

import { StyledInput } from './styles';
import { Props } from './types';

const FormInputRenderer: FC<Props> = ({ field }) => {
  const { control } = useFormContext<FormFields>();
  const validationRules = useMemo(
    () => getValidationRulesFromAField(field),
    [field],
  );
  const gridColumnAmount = useMemo(
    () => getGridColumnAmount(field.columnsAmount),
    [field.columnsAmount],
  );
  const gridOffsetColumnAmount = useMemo(
    () =>
      isDef(field.offsetColumnsAmount)
        ? getGridColumnAmount(field.offsetColumnsAmount)
        : undefined,
    [field.offsetColumnsAmount],
  );

  return (
    <>
      <Grid item xs={gridColumnAmount}>
        <FormField
          {...validationRules}
          defaultValue={field.defaultValue}
          controllerProps={{
            control,
            name: field.name,
          }}
          render={(props) => (
            <StyledInput
              {...props}
              disabled={field.disabled}
              error={props.error}
              extraRightContent={field.extraRightContent}
              label={field.label}
              multiline={field.multiline}
              readOnly={field.readOnly}
              required={field.required}
              rows={field.rows}
              maxRows={field.maxRows}
              secure={field.secure}
              placeholder={field.placeholder}
              prefix={field.prefix}
              postfix={field.postfix}
              showLabel={field.showLabel}
              type={InputTypes.text}
              value={props.value as FormFieldInputValueType}
              size={field.size as unknown as Sizes}
              loading={field.loading}
              autoComplete={field.autocomplete}
            />
          )}
        />
      </Grid>
      {isDef(gridOffsetColumnAmount) && (
        <Grid item xs={gridOffsetColumnAmount} />
      )}
    </>
  );
};

export default FormInputRenderer;
